import { Pipe, PipeTransform } from '@angular/core';

import { fixNewLines } from 'app/helpers/text';

@Pipe({
    name: 'stbyParagraphize',
})
export class ParagraphizePipe implements PipeTransform {
    transform(value: string): string[] {
        return fixNewLines(value);
    }
}
